import React, { useEffect, useRef } from 'react'

const ProgressBar = ({ onInitialize }) => {
  const progressBarRef = useRef(null)

  useEffect(() => {
    if (progressBarRef.current && onInitialize) {
      onInitialize(progressBarRef.current)
    }
  }, [onInitialize])

  return <div className="progress-bar" ref={progressBarRef}></div>
}

export default ProgressBar
